import React, { Component } from 'react';
import Button from 'rmwc/Button';
import Text from '../../components/Text';

export default ({ onClick }) => {
  return (
    <div className="text-center m-3">
      <Text use="caption">Prefer to get an independent perspective from someone outside of Harbor?</Text>
      <div>
        <Button onClick={onClick} theme="secondary" className="text-uppercase mt-2">
          Find Independent Advisor
        </Button>
      </div>
    </div>
  );
};
